module.exports = __webpack_public_path__ + "static/img/scratch_dialog_bg.9c6ab7c7.png";